import { abortNavigation, defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'

// always use a trailing slash for urls
export default defineNuxtRouteMiddleware((to) => {
  if (!to.path.endsWith('/') && !to.path.endsWith('.xml')) {
    const { path, query, hash } = to
    const nextPath = path + '/'
    const nextRoute = { path: nextPath, query, hash }

    abortNavigation()
    return navigateTo(nextRoute, {
      redirectCode: 301,
      replace: true,
      external: false
    })
  }
})
